import type { HTMLAttributes } from 'react';

import { cn } from '~lib/utils/style';

/** Skeleton placeholder with the system's signature 1.5s shine animation. */
function Skeleton({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      aria-hidden
      className={cn(
        'animate-shine rounded-md',
        'bg-[linear-gradient(110deg,hsl(var(--color-gray-100))_30%,hsl(var(--color-gray-050))_50%,hsl(var(--color-gray-100))_70%)]',
        'bg-[length:200%_100%]',
        className,
      )}
      {...props}
    />
  );
}

export { Skeleton };
